import { URLS } from "@app/shared";
import { PageHeader } from "@design-system/components";
import { trans } from "@mongez/localization";
import { ContactIrInfo } from "../components";

export function ContactIrPage() {
  return (
    <>
      <PageHeader
        translationKey="contactIr"
        breadcrumbItems={[
          { label: trans("home"), link: URLS.home },
          { label: trans("investorRelations"), link: URLS.investor.root },
          { label: trans("contactIr") },
        ]}
      />
      <ContactIrInfo />
    </>
  );
}
